import * as z from 'zod';

import { newsSchema } from './news';

export const marketHoursEnum = z.enum([
  'open_market',
  'pre_market',
  'closed_market',
]);
export type MarketHoursEnum = z.infer<typeof marketHoursEnum>;

export const marketOverviewSchema = z.object({
  id: z.string(),
  created_at: z.string().datetime(),
  updated_at: z.string().nullish(),
  date: z.string(),
  market_hours: marketHoursEnum,
  summary: z.string().nullish(),
  articles: z.array(z.string()),
  questions: z.array(z.string()),
});

export const marketOverviewResponse = z.object({
  summaries: z.array(marketOverviewSchema),
});

export type MarketOverview = z.infer<typeof marketOverviewResponse>;

export const marketOverviewWithNewsSchema = marketOverviewSchema.extend({
  articles: z.array(newsSchema),
});

export type MarketOverviewWithNews = z.infer<
  typeof marketOverviewWithNewsSchema
>;

export const marketOverview = {
  getMarketOverview: {
    path: ({
      fromDate,
      marketHours,
    }: {
      fromDate: string;
      marketHours?: MarketHoursEnum;
    }) => {
      let baseUrl = `market-overview/v1?from_date=${fromDate}`;
      return marketHours ? baseUrl + `&market_hours=${marketHours}` : baseUrl;
    },
    schema: marketOverviewResponse,
  },
};
